/** True when the value is a Bloom API avatar path (needs auth + blob fetch). */
export function isBloomDoctorAvatarApiPath(url) {
    if (!url)
        return false;
    return /\/v1\/doctors\/[^/]+\/avatar/.test(url);
}
